'use client';

import { Box } from '@mui/material';
import { usePathname, redirect } from 'next/navigation';
import { type PropsWithChildren } from 'react';

import { Loader } from '@/components/layout/loading';
import { useFeatureFlags, useLaunchDarkly } from '@/contexts/useFeatureFlags';
import { useRoles } from '@/contexts/useRoles';
import { useSourceAccounts } from '@/contexts/useSourceAccounts';
import { useUser } from '@/contexts/useUser';
import { getDocsUrl } from '@/docs/docsUrls';

export function AuthChecker({ children }: PropsWithChildren) {
  const { user, currentProjectId } = useUser();
  const { SkipOnboarding } = useFeatureFlags();
  const pathname = usePathname();
  const { isReady } = useLaunchDarkly();
  const { sourceAccounts } = useSourceAccounts();
  const { isGlobalRole, roles, permissions } = useRoles();

  const isApplicationReady =
    !!user &&
    !!currentProjectId &&
    !!sourceAccounts &&
    isReady &&
    roles.length > 0 &&
    Object.keys(permissions).length > 0;

  if (!isApplicationReady) {
    return <LoaderComponent />;
  }

  if (SkipOnboarding && !isGlobalRole(user.selectedRole)) {
    redirect(getDocsUrl('root'));
  }

  if (
    sourceAccounts?.length ||
    SkipOnboarding ||
    pathname.startsWith('/onboarding') ||
    pathname.startsWith('/global-management')
  ) {
    return children;
  }

  // redirect('/global-management/scanning-accounts');
  redirect('/onboarding');
}

const LoaderComponent = () => (
  <Box
    className='h-full'
    sx={{
      background: 'var(--mui-palette-background-pageGradient)',
    }}
  >
    <Loader />
  </Box>
);
